import { useEffect, useRef, useState } from "react";
import "./sharesocial.css";

const ShareSocial = ({ shareUrl, shareTitle, post }) => {
  const [showOptions, setShowOptions] = useState(false);
  const containerRef = useRef(null);

  const toggleShare = () => setShowOptions((prev) => !prev);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} className="share-container-inline">
      {/* Inline Share Button */}
      <button
        onClick={toggleShare}
        className="share-toggle-btn"
        aria-label="Share this post"
      >
        <i className="fa-solid fa-share-from-square"></i> Share
      </button>

      {/* Social Options with animation */}
      <div className={`share-options ${showOptions ? "show" : ""}`}>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            shareUrl
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="sharesocial"
        >
          <i className="fa-brands fa-square-facebook"></i>
        </a>

        <a
          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
            shareTitle
          )}&url=${encodeURIComponent(shareUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="sharesocial"
        >
          <i className="fa-brands fa-square-x-twitter"></i>
        </a>

        <a
          href={`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
            shareUrl
          )}&media=${encodeURIComponent(
            post.image?.url
          )}&description=${encodeURIComponent(shareTitle)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="sharesocial"
        >
          <i className="fa-brands fa-square-pinterest"></i>
        </a>
      </div>
    </div>
  );
};

export default ShareSocial;
